<template>
  <div class="row">
    <div class="col-6 mb-4">
      <div class="search-box chat-search-box w-50">
        <div class="position-relative">
          <input
            @input="leaveSearch()"
            type="search"
            class="form-control fa-lg text-light"
            :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            :placeholder="$t('popups.search')"
            v-model="leaveSearchModel"
            style="background-color: #2a3042 !important"
          />
          <i class="bx bx-search-alt search-icon text-light"></i>
        </div>
      </div>
    </div>
    <div class="col-6" style="display: flex; justify-content: flex-end">
      <button
        type="button"
        @click="addHrLeaves"
        class="btn btn-light float-end mb-4"
      >
        <span
          class="bx bxs-plus-circle float-end fa-2x"
          style="color: #2a3042 !important"
        ></span>
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">#</th>
          <th scope="col">{{ $t("hr_holidays.start_date") }}</th>
          <th scope="col">{{ $t("hr_holidays.end_date") }}</th>
          <th scope="col">{{ $t("hr_leaves.hr_leave_type_id") }}</th>
          <th scope="col">{{ $t("hr_leaves.is_legal") }}</th>
          <th scope="col">{{ $t("hr_leaves.descr") }}</th>
          <th scope="col">{{ $t("hr_leaves.file") }}</th>
          <th scope="col">{{ $t("hr_leaves.created") }}</th>
          <th scope="col">{{ $t("hr_leaves.updated") }}</th>
          <th scope="col">{{ $t("hr_employees.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app, index) in HrLeaves" :key="app" class="text-center">
          <td>{{ (leavesPage - 1) * this.leavesLimit + index + 1 }}</td>
          <td>{{ app?.start_date }}</td>
          <td>{{ app?.end_date }}</td>
          <td>
            {{
              $i18n.locale === "en"
                ? app?.hr_leave_type?.name_en ?? "other"
                : app?.hr_leave_type?.name ?? "أخرى"
            }}
          </td>
          <td v-if="app?.is_legal">{{ app?.is_legal ? "Yes" : "No" }}</td>
          <td v-if="!app?.is_legal">
            {{ app?.hr_leave_type?.is_legal ? "Yes" : "No" }}
          </td>
          <td>{{ app?.descr }}</td>
          <td>
            <!-- <a
                    v-if="app?.file"
                    >download file</a
                  > -->
            <a
              v-if="app?.file"
              :href="`${this.$store.state.mediaUrl}/${app.file}`"
              target="_blank"
              >{{ $t("popups.download_file") }}</a
            >
            <span v-else> - </span>
          </td>
          <td>{{ app.created.split("T")[0] }}</td>
          <td>{{ app.updated.split("T")[0] }}</td>

          <td class="d-flex">
            <button
              class="btn btn-primary mx-1"
              href="javascript: void(0);"
              data-bs-toggle="modal"
              data-bs-target="#editLeave"
              @click="getLeaves(app)"
            >
              {{ $t("popups.edit") }}
            </button>
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteHrLeaves(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- end  table -->

  <!--Start Add leave modal-->
  <div
    class="modal fade"
    id="addLeave"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  ></div>
  <!--End leave modal -->

  <!--Start Edit leave modal-->
  <div
    class="modal fade"
    id="editLeave"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container px-0">
            <form @submit.prevent="editHrLeaves()">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  {{ $t("popups.edit") }}
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  style="position: relative"
                ></button>
              </div>

              <div class="mb-3">
                <label class="form-label">
                  {{ $t("hr_holidays.start_date") }}
                </label>
                <input
                  type="date"
                  v-model="selectedLeaveTypeEmployee.start_date"
                  class="form-control"
                />
              </div>

              <div class="mb-3">
                <label class="form-label">
                  {{ $t("hr_holidays.end_date") }}
                </label>
                <input
                  type="date"
                  v-model="selectedLeaveTypeEmployee.end_date"
                  class="form-control"
                />
              </div>

              <div class="mb-3 mt-4">
                <label for="exampleInputEmail1" class="form-label">
                  {{ $t("hr_leaves.hr_leave_type_id") }}
                </label>
                <select
                  class="form-select"
                  aria-label="Default select example"
                  v-model="selectedLeaveTypeEmployee.hr_leave_type_id"
                  @change="showIsLeagal"
                >
                  <option
                    v-for="leave in HrLeavesTypes"
                    :key="leave"
                    :value="leave.id"
                  >
                    {{
                      $i18n.locale === "en"
                        ? app?.hr_leave_type?.name_en ?? "other"
                        : app?.hr_leave_type?.name ?? "أخرى"
                    }}
                  </option>
                </select>
              </div>

              <div class="mb-3 mt-4" v-if="selectedLeaveTypeEmployee.is_legal">
                <label for="exampleInputEmail1" class="form-label">
                  {{ $t("hr_leaves.is_legal") }}
                </label>
                <select
                  required
                  class="form-select"
                  aria-label="Default select example"
                  v-model="selectedLeaveTypeEmployee.is_legal"
                >
                  <option
                    v-for="condition in leaglConditions"
                    :key="condition"
                    :value="condition.value"
                  >
                    {{ condition.name }}
                  </option>
                </select>
              </div>

              <label class="form-label">
                {{ $t("hr_leaves.descr") }}
              </label>
              <textarea
                v-model="selectedLeaveTypeEmployee.descr"
                id="descr"
                class="form-control"
                cols="30"
                rows="10"
              ></textarea>
              <!-- <div class="mb-3 mt-4">
                      <label class="form-label"
                        >{{ $t("hr_leaves.file") }} :
                        <span class="text-gray">
                          {{
                            selectedLeaveTypeEmployee?.file
                              ? selectedLeaveTypeEmployee?.file.split("/")[2]
                              : ""
                          }}
                        </span>
                      </label>
                      <input
                        name="file"
                        @change="onFileChange($event)"
                        type="file"
                        class="form-control"
                      />
                    </div> -->
              <div
                class="modal-footer"
                :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              >
                <button
                  type="submit"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  {{ $t("popups.edit") }}
                </button>
                <button
                  data-bs-dismiss="modal"
                  type="button"
                  class="btn btn-danger"
                >
                  {{ $t("popups.cancel") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End Edit leave modal -->

  <div>
    <!--   Apps  Pagination     -->
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: leavesPage == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="getHrLeaves(leavesPage - 1, false)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == leavesPage }"
        v-for="p in leavesTotalPages"
        :key="p"
      >
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="getHrLeaves(p, false)"
          >{{ p }}</a
        >
      </li>

      <li
        class="page-item"
        :class="{ disabled: leavesPage == leavesTotalPages }"
      >
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="getHrLeaves(leavesPage + 1, false)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      leaveSearchMode: false,
      leaveSearchModel: "",
      HrLeaves: [],
      HrLeavesTypes: [],
      leaglConditions: [
        { name: "Yes", value: 1 },
        { name: "No", value: 0 },
      ],
      isLegal: false,
      leaveType: {
        date: null,
        descr: null,
      },
      selectedLeaveTypeEmployee: {},
      leavesLimit: 2,
      leavesPage: 1,
      leavesTotalPages: 0,
    };
  },
  methods: {
    getHrLeaves(page, tabClick) {
      console.log("step 263 :", this.HrLeaves.length, tabClick);
      if (this.HrLeaves.length > 0 && tabClick) return;
      this.http
        .post("hr-leaves/employee/pagination", {
          limit: this.leavesLimit,
          page,
          id: parseInt(this.$route.params.id),
        })
        .then((res) => {
          this.leavesPage = page;
          this.leavesTotalPages = Math.ceil(res.tot / this.leavesLimit);
          this.HrLeaves = res.data;
        });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0], true);
    },
    deleteHrLeaves(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http
            .post("hr-leaves/delete-leave-file", {
              id: app.id,
              file: app?.file,
            })
            .then(() => {
              this.getHrLeaves(this.leavesPage, false);
            });
        }
      });
    },
    getLeaves(app) {
      if (app) {
        this.selectedLeaveTypeEmployee = app;
      }
      if (this.HrLeavesTypes.length <= 0) {
        this.http.post("hr-leave-types/get-types", {}).then((resp) => {
          if (resp.status) {
            this.HrLeavesTypes = resp.data;
            // this.HrLeavesTypes.push({ name: "other", id: null });
          }
        });
        return;
      }
    },
    addHrLeaves() {
      var data = {
        title: this.$t("popups.add"),
        inputs: [
          {
            model: "start_date",
            type: "date",
            label: this.$t("hr_holidays.start_date"),
            required: true,
          },
          {
            model: "end_date",
            type: "date",
            label: this.$t("hr_holidays.end_date"),
            required: true,
          },
          {
            model: "hr_leave_type_id",
            type: "select",
            label: this.$t("hr_leaves.hr_leave_type_id"),
            options: this.HrLeavesTypes.map((item) => ({
              value: item.id,
              label: this.$i18n.locale === "en" ? item.name_en : item.name,
            })),
            required: true,
          },
          {
            model: "descr",
            type: "textarea",
            label: this.$t("hr_leaves.descr"),
          },
          {
            model: "file",
            type: "file",
            label: this.$t("hr_leaves.file"),
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.hr_employee_id = parseInt(this.$route.params.id);
              console.log("obj", obj);
              if (!obj.hr_leave_type_id) {
                delete obj.hr_leave_type_id;
              }
              if (obj?.file) {
                this.http.do("hr-leaves", obj).then(() => {
                  this.getHrLeaves(this.leavesPage, false);
                  this.leaveType = { date: null, descr: null };
                });
              } else {
                this.http.post("hr-leaves", obj).then(() => {
                  this.getHrLeaves(this.leavesPage, false);
                  this.leaveType = { date: null, descr: null };
                });
              }
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editHrLeaves() {
      this.http
        .put(
          "hr-leaves",
          this.selectedLeaveTypeEmployee.id,
          this.selectedLeaveTypeEmployee
        )
        .then(() => {
          this.getHrLeaves(this.leavesPage, false);
        });
    },
    showIsLeagal() {
      if (this.leaveType.hr_leave_type_id) {
        this.isLegal = false;
        return;
      }
      this.isLegal = true;
      console.log({
        type: this.leaveType,
        types: this.HrLeavesTypes,
        leagal: this.isLegal,
      });
    },
    leaveSearch() {
      if (!this.leaveSearchModel.length)
        return this.getHrLeaves(this.page, false);
      this.leaveSearchMode = true;
      this.leavesTotalPages = 0;
      this.http
        .post("hr-leaves/leave-search", {
          search: this.leaveSearchModel,
          limit: this.limit,
          page: this.page,
          col: "descr",
        })
        .then((res) => {
          this.HrLeaves = res.data;
          console.log("######## files", this.HrLeavesTypes);
        });
    },
  },
  mounted() {
    this.getHrLeaves(1, true);
    this.getLeaves(false);
  },
};
</script>
<style lang=""></style>
